<template>
    <div class="min-h-screen bg-gray-100">
        <navbar/>
        <router-view></router-view>
        <div class="text-sm flex justify-center">
        <p>Powered by <b><a href="https://combodigital.pe/?client_reference=FCCTP-USMP" target="_blank"> ComboDigital.pe</a></b></p>
    </div>
    </div>
</template>

<script>
import Navbar from "@/components/layout/shared/navbar";

export default {
    name: "helpdesk",
    metaInfo() {
        return {
            title: this.$i18n.t('Helpdesk'),
            titleTemplate: '%s - ' + this.$store.state.settings.name
        }
    },
    components: {Navbar},
}
</script>